import { ReviewsDetailsContainer } from '../ReviewsDetails/ReviewsDetails';
import * as React from 'react';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { trackReviewsTeaserView } from './tracking';
import { ReviewsTeaserContainer } from '../ReviewsTeaser';
import { Responsive } from '@cian/ui-kit';
import { ReviewsTeaserMobileContainer } from '../ReviewsTeaserMobile';
import { useSelector } from 'react-redux';
import { getReviews } from '../../selectors/developerV2';

export const Reviews = () => {
  const reviews = useSelector(getReviews);

  const trackingReviewsTeaserView = React.useCallback(() => {
    trackReviewsTeaserView();
  }, []);

  if (!reviews || reviews.length === 0) {
    return null;
  }

  return (
    <>
      <ActionAfterViewed callback={trackingReviewsTeaserView}>
        <>
          <Responsive desktop>
            <ReviewsTeaserContainer />
          </Responsive>
          <Responsive phone tablet>
            <ReviewsTeaserMobileContainer />
          </Responsive>
        </>
      </ActionAfterViewed>

      <ReviewsDetailsContainer />
    </>
  );
};
